export class DtoTabla {
    id: number;
    codigo: string;
    nombre: string;
    descripcion: string;
    estadoId: string;
    estado:string
    estadoNombre: string;
    valorint1:number

}